var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ctint-main-tab-layout',{attrs:{"namespace":_vm.namespace,"mode":_vm.mode},on:{"openSelectedTask":_vm.openSelectedTask},scopedSlots:_vm._u([{key:"left",fn:function(){return undefined},proxy:true},{key:"middle",fn:function(){return undefined},proxy:true},{key:"right",fn:function(){return undefined},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }